import {
  links as kambiLinks,
  config as kambiConfig
} from "../Kambi/Config.resource";

export const links = {
  ...kambiLinks,
  myRewards: "/my-rewards/",
  blog: "https://www.888sport.se/blog/",
  appNativeSmartLinkIOS: "https://sportcom.onelink.me/LlDF/5q4bfsv3",
  appNativeSmartLinkAndroid: "https://sportse.onelink.me/n4hf/zdk1mxiu"
};

export const config = {
  ...kambiConfig
};
